module.exports = __webpack_public_path__ + "img/factor_a_gray.26852cdc.svg";